module.exports = __webpack_public_path__ + "static/media/coordenadas.0c6b8427.svg";